import clsx from 'clsx';
import styles from './InputLabel.module.scss';

interface InputLabelWrapperProps {
  id: string;
  children: React.ReactNode;
  description?: string;
  margin?: InputLabelPropsMargin;
}

const InputLabelWrapper = ({ id, children, description, margin }: InputLabelWrapperProps) => {
  if (!description) {
    return <>{children}</>;
  }

  return (
    <div
      className={clsx(styles.descriptionWrapper, {
        [styles.descriptionWrapperNoMargin]: margin === 'none',
      })}
    >
      {children}
      <p className={styles.description} id={id}>
        {description}
      </p>
    </div>
  );
};

type InputLabelPropsMargin = 'none';

export interface InputLabelProps {
  children: React.ReactNode;
  htmlFor: string;
  meta?: string;
  description?: string;
  margin?: InputLabelPropsMargin;
}

export const InputLabel = ({ children, htmlFor, meta, description, margin }: InputLabelProps) => (
  <InputLabelWrapper description={description} id={`${htmlFor}-description`} margin={margin}>
    <label
      className={clsx(styles.label, {
        [styles.labelNoMargin]: margin === 'none',
      })}
      htmlFor={htmlFor}
    >
      {children}
      {meta && <span className={styles.meta}>{meta}</span>}
    </label>
  </InputLabelWrapper>
);

interface InputLabelGhostProps {
  className?: string;
}

export const InputLabelGhost = ({ className }: InputLabelGhostProps) => (
  <div className={clsx(styles.ghost, className)} aria-hidden="true" />
);
